(function () {
    'use strict';

    angular
        .module('core.services')
        .service('MeService', MeService)

    /** @ngInject */
    function MeService(HttpService) {
        const MeService = {
            getMe: getMe,
            updateMe: updateMe,
            updateMePassword: updateMePassword,
            saveImage: saveImage,
            deleteImage: deleteImage
        }

        return MeService;

        function getMe() {
            return HttpService.get('/me');
        }

        function updateMe(meData) {
            return HttpService.put('/me', meData);
        }

        function updateMePassword(mePasswordData) {
            return HttpService.put('/me/change-password', mePasswordData);
        }

        function saveImage(meImageData) {
            return HttpService.post('/me/images', meImageData);
        }

        function deleteImage(meImageId) {
            return HttpService.delete('/me/images', meImageId);
        }
    }
}());